import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { Icon } from 'antd'

import { UnApprovedCause } from '../../types'

import styles from '../../styles/StickerUnApprovedCauseCard.module.css'

export default function UnApprovedCauseCard({
  unApprovedCauses,
  position,
}: {
  unApprovedCauses: UnApprovedCause[]
  position: 'top' | 'right'
}) {
  const intl = useIntl()
  const code = intl.locale as 'ko' | 'en'
  return (
    <div
      className={position === 'top' ? styles.wrapperTop : styles.wrapperRight}
    >
      <div className={styles.head}>
        <Icon
          type="exclamation-circle"
          theme="filled"
          style={{ color: '#FFBF00' }}
        />

        <FormattedMessage id="StickerInfo.unapproved.alert.title.edit" />
      </div>

      {unApprovedCauses.map((cause) => {
        return (
          <div key={cause.relatedId.objectId} className={styles.line}>
            {cause.relatedId.objectId === '285840fnIL' ||
            cause.relatedId.objectId === 'KsgFQT28cG'
              ? cause.relatedId.explain[code].subtitle
              : cause.relatedId.explain[code].title}
          </div>
        )
      })}
    </div>
  )
}
